
import { defineComponent, ref, computed, toRefs, watch } from "vue"
import { useStore } from "vuex"
import { Actions } from "@/store/enums/StoreEnums"
import { ElMessage } from "element-plus"
import { CardPool, CardPoolSimulationResult } from "@/store/modules/CardPoolModule"

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    cardPool: {
      type: Object as () => CardPool | null,
      default: null
    }
  },
  emits: ['update:visible', 'simulated'],
  setup(props, { emit }) {
    const store = useStore()
    const { cardPool, visible } = toRefs(props)

    const simulationCount = ref(10000)
    const loading = ref(false)
    const result = ref<CardPoolSimulationResult | null>(null)

    const priceYuan = computed(() => {
      if (!cardPool.value) return 0
      return Number(cardPool.value.price).toFixed(2)
    })

    const avgRewardYuan = computed(() => {
      if (!result.value) return 0
      return Number(result.value.avg_reward_value).toFixed(2)
    })

    const expectedProfitYuan = computed(() => {
      if (!result.value) return 0
      return Number(result.value.expected_profit).toFixed(2)
    })

    const getRarityTagType = (rarity: string) => {
      const map: Record<string, string> = {
        'SSSR': 'danger',
        'SSR': 'warning',
        'SR': 'success',
        'R': 'info',
      }
      return map[rarity] || ''
    }

    const getProgressColor = (percentage: number) => {
      if (percentage >= 30) return '#F56C6C'
      if (percentage >= 15) return '#E6A23C'
      return '#67C23A'
    }

    const runSimulation = async () => {
      if (!cardPool.value?.id) {
        ElMessage.error('请先选择卡池')
        return
      }

      loading.value = true
      try {
        const data = await store.dispatch(Actions.SIMULATE_CARD_POOL, {
          id: cardPool.value.id,
          times: simulationCount.value
        })
        if (data.success === false) {
          ElMessage.error(data.error_msg || '模拟失败')
          return
        }
        result.value = data
        emit('simulated', data)
      } catch (error: unknown) {
        const errorMsg = (error as { error_msg?: string })?.error_msg || '模拟失败'
        ElMessage.error(errorMsg)
      } finally {
        loading.value = false
      }
    }

    // 当弹窗打开时重置结果
    watch(visible, (newVal) => {
      if (newVal) {
        result.value = null
      }
    })

    return {
      simulationCount,
      loading,
      result,
      priceYuan,
      avgRewardYuan,
      expectedProfitYuan,
      getRarityTagType,
      getProgressColor,
      runSimulation
    }
  }
})
